// Campus photo for /colleges/university-of-louisville: CC BY-SA 2.0, by Ken Lund from Las Vegas, Nevada, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Louisville%2C_Louisville%2C_Kentucky_(95106009).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-louisville/; credited under the photo.
const photo = {
    "slug": "university-of-louisville",
    "alt": "Grawemeyer Hall behind the University of Louisville entrance wall on the Belknap Campus in Louisville, Kentucky",
    "src": "/colleges/university-of-louisville/campus-1600.webp",
    "srcSmall": "/colleges/university-of-louisville/campus-800.webp",
    "srcMid": "/colleges/university-of-louisville/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-louisville/og.jpg",
    "title": "University of Louisville, Louisville, Kentucky (95106009)",
    "author": "Ken Lund from Las Vegas, Nevada, USA",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Louisville%2C_Louisville%2C_Kentucky_(95106009).jpg",
    "read": "2026-10-01"
};

export default photo;
